import {
  INotification,
  NotificationStatus
} from '@/modules/in-app-notification/types/notificationTypes'
import axios from 'axios'
import { ModelApi } from '@/services/api/modelApi'
import { Id } from '@/shared/types/builtInTypes'
export default class InAppNotificationEndpoint extends ModelApi<INotification> {
  constructor() {
    super('in_app', 'notification')
  }

  /**
   * Marks all notifications as read.
   * @returns {Promise<void>} A promise that resolves when the operation is complete.
   */
  async markAllAsRead(): Promise<void> {
    return new Promise((resolve, reject) => {
      axios
        .post(`${this.getUrl()}mark_all_as_read/`)
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  /**
   * Marks a specific notification as read.
   * @param {number} id - The ID of the notification to mark as read.
   * @returns {Promise<void>} A promise that resolves when the operation is complete.
   */
  async markAsRead(id: Id): Promise<void> {
    return new Promise((resolve, reject) => {
      axios
        .post(`${this.getUrl()}${id}/mark_as_read/`, {
          status: NotificationStatus.READ
        })
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  /**
   * Retrieves the badge count for notifications.
   * @returns {Promise<number>} A promise that resolves to the count of unread notifications.
   */
  async getBadgeCount(): Promise<number> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${this.getUrl()}unread_count/`)
        .then(response => {
          resolve(response.data.count)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
